import { sleep } from "@/lib/utils";

import type { Api, InspirationIdea, InspirationIdeaFeedItem } from "../types";

const ideas: InspirationIdea[] = [
	{
		id: "idea_demo_1",
		title: "Quiet luxury capsule",
		description: "A visual collection of minimal tailoring, soft neutrals, and long-life staples.",
		coverPhoto:
			"https://images.unsplash.com/photo-1496747611176-843222e1e57c?auto=format&fit=crop&w=900&q=80",
		productCount: 12,
		createdAt: "2026-05-01T11:00:00Z",
		updatedAt: "2026-05-01T11:00:00Z",
	},
	{
		id: "idea_demo_2",
		title: "Warm home corners",
		description: "Curated home objects, ceramics, lighting, and textures for cozy discovery blocks.",
		coverPhoto:
			"https://images.unsplash.com/photo-1513161455079-7dc1de15ef3e?auto=format&fit=crop&w=900&q=80",
		productCount: 9,
		createdAt: "2026-05-01T11:05:00Z",
		updatedAt: "2026-05-01T11:05:00Z",
	},
	{
		id: "idea_demo_3",
		title: "Handmade gifts under 5k",
		description: "A client-facing idea collection for affordable crafted gifts and impulse saves.",
		coverPhoto:
			"https://images.unsplash.com/photo-1512909006721-3d6018887383?auto=format&fit=crop&w=900&q=80",
		productCount: 18,
		createdAt: "2026-05-01T11:10:00Z",
		updatedAt: "2026-05-01T11:10:00Z",
	},
];

type IdeaFeedRecord = Omit<InspirationIdeaFeedItem, "idea">;

let records: IdeaFeedRecord[] = ideas.map((idea, index) => ({
	id: `idea_feed_demo_${index + 1}`,
	ideaId: idea.id,
	sortOrder: index,
	createdAt: idea.createdAt,
	updatedAt: idea.updatedAt,
}));

const hydrate = (record: IdeaFeedRecord): InspirationIdeaFeedItem => {
	const idea = ideas.find((item) => item.id === record.ideaId);
	if (!idea) throw new Error("Idea not found");
	return { ...record, idea };
};

const orderedRecords = () => [...records].sort((a, b) => a.sortOrder - b.sortOrder);

export const inspirationIdeas: Api["inspirationIdeas"] = {
	async list() {
		await sleep(150);
		return orderedRecords().map(hydrate);
	},

	async reorder(ids) {
		await sleep(180);
		const next: IdeaFeedRecord[] = [];
		for (const id of ids) {
			const found = records.find((record) => record.id === id);
			if (found) next.push(found);
		}
		for (const record of records) {
			if (!ids.includes(record.id)) next.push(record);
		}
		const now = new Date().toISOString();
		records = next.map((record, index) => ({
			...record,
			sortOrder: index,
			updatedAt: now,
		}));
		return this.list();
	},
};
